import { useState, useEffect, Fragment } from "react";
import { Box, Button, Typography, Grid, Stack } from "@mui/material";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { Link, useNavigate, useParams,useOutletContext } from "react-router-dom";
import MpgInput from "../../../../../CommonFormComp/MpgInput";
import MpgItem from "../../../../../CommonFormComp/MpgItem";
import MpgFileUpload from "../../../../../fileHandling/MpgFileUpload";
import MpgAutocompleteSingle from "../../../../../CommonFormComp/MpgAutocompleteSingle";
import {
  useGetClientAccountDropdownMutation,
  useGetSubAcccountByClientAccountIdQuery,
} from "../../../../../reactQueries/AppApi/rqHooksForClientUsers";
import {
  useFileDownloadMutation,
  useGetAllClientResourceTypesListQuery,
  useGetAllReportResourceScopeListQuery,
  useGetServiceOfficeListMutation,
} from "../../../../../reactQueries/commonRQHooks";
import { editClientSpeReportValidation } from "./editClientSpeReportValidation";
import { useCreateReportResourceMutation, useUploadClientSpecificReportFileMutation } from "../../../../../reactQueries/AppApi/rqHooksForClientSpecificReports";
import MpgServiceOfficeDialog from "../../../../../CommonFormComp/MpgServiceOfficeListDialog/MpgServiceOfficeDialog";
import CircularProgress from '@mui/material/CircularProgress';

import { useGetClientSubAccountByIdQuery } from "../../../../../reactQueries/AppApi/rqHooksForClientSubAccount";
import { useGetClientAccountByIdQuery } from "../../../../../reactQueries/AppApi/rqHooksForClientAccount";
import { useGetSignedInUserDetails } from "../../../../../hooksAndFunctions/customHooks/useGetSignedInUserDetails";
import { clientSpecificReportViewPath } from "../../../../../routes/routePaths";
import MpgErrorDialog from "../../../../../common/dialog/MpgErrorDialog";
import MpgLoadingDialog from "../../../../../common/dialog/MpgLoadingDialog";
import { saveAs } from "file-saver";
import MuiLink from '@mui/material/Link';
import WarningAlert from "../../../../../common/dialog/alerts/WarningAlert";
import { useGetLoggedInUserDetails } from "../../../../../hooksAndFunctions/customHooks/useGetLoggedInUserDetails";
import useTrackUserActivity from "../../../../../userActivityTracking/useTrackUserActivity";
import { getGUIDAndExtentionFromFileURL } from "../../../../../hooksAndFunctions/functions/getGUIDAndExtentionFromFileURL";
import { useGetAccountAndSubAccListOnlyForA4Role } from "../../../../../hooksAndFunctions/customHooks/useGetAccountAndSubAccListOnlyForA4Role";
import { getAccessTypes } from "../../../../../hooksAndFunctions/functions/getAccessTypes";

const EditClientSpecificReport = ({ clientSpecificReportDataById }) => {
  const {refClientSpecificCmsData}=useOutletContext();
  const { id: csrId } = useParams()
  const navigate = useNavigate()
  const { userName } = useGetSignedInUserDetails()

  const { loggedInUser } = useGetLoggedInUserDetails();
  const { clientPortalAdminRoleId, isEnterpriseAdmin, id: userId } = loggedInUser;

  const {
    clientPortalAdminType
  } = getAccessTypes()
  const {
    hasA2Access,
    hasA4Access
  } = clientPortalAdminType

  /**useful for only A4 role */
  const { clientAccountIdListForA4Role, clientSubAccountIdListForA4Role } = useGetAccountAndSubAccListOnlyForA4Role({ userId })
  /** !!!!!!!! form handling  !!!!!!!! */

  const { schema } = editClientSpeReportValidation()

  const rhfFormInstance = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      title: clientSpecificReportDataById?.Title || "",
      description: clientSpecificReportDataById?.Description || "",
    }
  });

  const { watch, setValue } = rhfFormInstance;

  const selectedClientAccount = watch("client_account");
  const selectedVisibleTo = watch("visible_to");

  const selectedClientAccountId = selectedClientAccount?.id

  /** !!!!!!!! API calls  !!!!!!!! */
  const { mutate: DownloadProfileImg, isError: isErrorOnDownload, isSuccess: isSuccessOnDownload, data: dataOnDownload } = useFileDownloadMutation()

  const {
    mutate: updateReportResource,
    isError: isErrorOnUpdate,
    isLoading: isLoadingOnUpdate,
    isSuccess: isSuccessOnUpdate,
    error: errorOnUpdate,
  } = useCreateReportResourceMutation();/**hook is same for create and update for this feature */

  const { mutate: uploadClientSpecificReportFile, isError: isErrorOnCsrFileUpload, isLoading: isLoadingOnCsrFileUpload, isSuccess: isSuccessOnCsrFileUpload, data: dataOnCsrFileUpload, error: errorOnCsrFileUpload } = useUploadClientSpecificReportFileMutation()

  // api - get report/resource types dropdown list
  const {
    data: resourceTypesList,
  } = useGetAllClientResourceTypesListQuery();

  // api - get visisble to dropdown list
  const { data: visibleToListData } = useGetAllReportResourceScopeListQuery();

  // api - get client accounts list
  const { mutate: getClientAccountList,
    data: clientAccountList } = useGetClientAccountDropdownMutation();

  useEffect(() => {
    getClientAccountList({ loggedInUserId: userId, roleId: clientPortalAdminRoleId, isEnterpriseAdmin })
  }, [loggedInUser])

  const clientAccountListData = clientAccountList?.data

  // api - get sub client account list by acc id.
  const {
    data: clientSubAccListData,
  } = useGetSubAcccountByClientAccountIdQuery({
    ClientAccountId: selectedClientAccountId
  });

  const {
    mutate: getServiceOfficeListData,
    isLoading: isLoadingOnServiceOfficeList,
    data: serviceOfficeListData,
  } = useGetServiceOfficeListMutation();

  useEffect(() => {
    getServiceOfficeListData()
  }, []);

  const { isSuccess: isSuccessOnClientAccountById, data: clientAccountById } = useGetClientAccountByIdQuery({ clientAccountId: clientSpecificReportDataById?.ClientAccountId })

  const { isSuccess: isSuccessOnClientSubAccountById, data: clientSubAccountById } = useGetClientSubAccountByIdQuery({ clientSubAccountId: clientSpecificReportDataById?.ClientSubAccountId })


  /** !!!!!!!! autocomplete Lists  !!!!!!!! */
  // visible to all auto complete list
  const visibleToAutocompleteList =
    !!visibleToListData &&
    visibleToListData?.map((item) => {
      return {
        id: item.Id,
        selectOptionLabel: item.Scope,
        selectOptionValue: item.Id,
        extraData: item,
      };
    });

  //get only reports from resource types
  const reportsAsResourceType =
    !!resourceTypesList &&
    resourceTypesList.filter((item) => {
      if (item?.Type === "Reports") {
        return {
          id: item.Id,
          selectOptionLabel: item.Type,
          selectOptionValue: item.Id,
          extraData: item,
        };
      }
    });

  // client account auto complete list
  const clientAccountAutocompleteList =
    !!clientAccountListData &&
    clientAccountListData.map((item) => {
      const disableOptionForA4Role = !clientAccountIdListForA4Role.includes(item?.Id)

      let disableOption = false

      if (!item.IsActive) {
        disableOption = true
      } else {
        if ((!!hasA4Access || !!hasA2Access) && !!disableOptionForA4Role) {
          if (selectedVisibleTo?.selectOptionLabel === "Everyone" ||
            selectedVisibleTo?.selectOptionLabel === "Client Account") {
            disableOption = true
          } else {
            disableOption = false
          }

        } else {
          /**for rest of roles */
          disableOption = false
        }
      }

      return {
        id: item.Id,
        selectOptionLabel: `${item.ClientAccountName}`,
        selectOptionValue: item.Id,
        selectOptionDisabled: !!disableOption,
        extraData: item,
      };
    });

  // sub account auto complete list
  const clientSubAcctAutocompleteList =
    !!clientSubAccListData &&
    clientSubAccListData
    //!!clientSubAccListData?.data &&
    //clientSubAccListData?.data
      .map((item) => {
        const disableOptionForA4Role = !clientSubAccountIdListForA4Role.includes(item?.Id)

        let disableOption = false

        /**disable option is client sub acc is Inactive */
        if (!item.IsActive) {
          disableOption = true
        } else {
          /**(only for A4 role) get all clinet sub acc ids where this user is not A4 admin and diable those autocomplete options */
          if ((!!hasA4Access || !!hasA2Access) && !!disableOptionForA4Role) {
            disableOption = true
          } else {
            /**for rest of roles */
            disableOption = false
          }
        }
        return {
          id: item.Id,
          selectOptionLabel: `${item.ClientAccountName}`,
          selectOptionValue: item.Id,
          selectOptionDisabled: !!disableOption,
          extraData: item,
        };
      });

  /** !!!!! handling service offices !!!!!!!! */
  const [openServiceOfficeDialog, setOpenServiceOfficeDialog] = useState(false);

  /**service office selected data state */
  const [serviceOfficeItemsFromDialog, setServiceOfficeItemsFromDialog] = useState([])

  useEffect(() => {
    if (!!serviceOfficeItemsFromDialog && serviceOfficeItemsFromDialog.length) {
      const list = serviceOfficeItemsFromDialog.map((item) => {
        return item.masterRightOfficeName
      })
      setValue('service_office', list.toString(), { shouldValidate: true })
    } else {
      setValue("service_office", "");
    }
  }, [serviceOfficeItemsFromDialog])

  useEffect(() => {
    if (!!clientSpecificReportDataById && !!clientSpecificReportDataById?.ClientServiceOffices) {

      let existingServiceOfficeObjList = []
      let existingServiceOfficeOnlyNameList = []

      clientSpecificReportDataById?.ClientServiceOffices.forEach((eachServiceOffice) => {
        const foundItem = !!serviceOfficeListData?.data && serviceOfficeListData?.data.find((item) => {
          return item.rightOfficeKey === eachServiceOffice.rightOfficeKey;
        });

        if (!!foundItem) {
          existingServiceOfficeObjList.push(foundItem)
          existingServiceOfficeOnlyNameList.push(foundItem.masterRightOfficeName)
        }
      })
      setValue("service_office", existingServiceOfficeOnlyNameList.toString(), { shouldValidate: true });
      /**setting values to dialog too */
      setServiceOfficeItemsFromDialog(existingServiceOfficeObjList)

    }
  }, [serviceOfficeListData?.data, clientSpecificReportDataById]);

  /** !!!!!!!!! setting default values !!!!!!!!! */
  useEffect(() => {
    if (!!visibleToListData && !!visibleToListData.length) {
      const foundItem = visibleToListData.find((item) => {
        return item.Id === clientSpecificReportDataById.ScopeId;
      });

      if (!!foundItem) {
        const selectedValue = {
          id: foundItem.Id,
          selectOptionLabel: `${foundItem.Scope}`,
          selectOptionValue: foundItem.Id,
          extraData: foundItem,
        };
        setValue("visible_to", selectedValue, {
          shouldValidate: true,
        });
      }
    }
  }, [visibleToListData, clientSpecificReportDataById]);


  useEffect(() => {
    if (!!isSuccessOnClientAccountById && !!clientAccountById) {
      const selectedValue = {
        id: clientAccountById?.Id,
        selectOptionLabel: `${clientAccountById?.ClientAccountName}`,
        selectOptionValue: clientAccountById?.Id,
      };

      setValue("client_account", selectedValue || "", {
        shouldValidate: true,
      });
    }
  }, [isSuccessOnClientAccountById, clientAccountById])

  useEffect(() => {
    if (!!isSuccessOnClientSubAccountById && !!clientSubAccountById) {
      const selectedValue = {
        id: clientSubAccountById.Id,
        selectOptionLabel: `${clientSubAccountById.ClientAccountName}`,
        selectOptionValue: clientSubAccountById.Id,
      };
      setValue("client_sub_account", selectedValue || {}, {
        shouldValidate: true,
      });
    }
  }, [isSuccessOnClientSubAccountById, clientSubAccountById])

  /** !!!!!!!!  disable dependent fields !!!!!!!!!!!!  */
  const [disableClientAccount, setDisableClientAccount] = useState(false);
  const [disableClientSubAccount, setDisableClientSubAccount] = useState(false);
  const [disableServiceOffice, setDisableServiceOffice] = useState(false);

  useEffect(() => {
    if (!selectedVisibleTo) {
      setDisableClientAccount(true);
      setDisableClientSubAccount(true);
      setDisableServiceOffice(true);
    } else if (selectedVisibleTo) {
      if (
        selectedVisibleTo?.selectOptionLabel === "Everyone" ||
        selectedVisibleTo?.selectOptionLabel === "Client Account"
      ) {
        setDisableClientAccount(false); // removed disable,
        setDisableClientSubAccount(true);
        setDisableServiceOffice(true);
      }
      if (selectedVisibleTo?.selectOptionLabel === "Client Sub-Account Group") {
        setDisableClientAccount(false);
        setDisableClientSubAccount(false);
        setDisableServiceOffice(true);
      }
      if (selectedVisibleTo?.selectOptionLabel === "Region") {
        setDisableClientAccount(false);
        setDisableClientSubAccount(false);
        setDisableServiceOffice(false);
      }
    }
  }, [selectedVisibleTo]);

  /**handling and processing for file download */
  const [fileDetails, setFileDetails] = useState({})
  /**{
   *  fileGUID:"dsdsdsdsdsdd",
   * fileExtension:"png",
   * } */
  useEffect(() => {
    if (!!clientSpecificReportDataById?.ReportUrl) {
      const file = clientSpecificReportDataById?.ReportUrl

      const splitFileURL = file.split("/")

      const fileGUIDWithExtension = splitFileURL.at(-1)

      const fileGUIDWithExtensionSplit = fileGUIDWithExtension.split('.')

      const fileGUID = fileGUIDWithExtensionSplit[0]
      const fileExtension = fileGUIDWithExtensionSplit[1]

      setFileDetails({
        fileGUID,
        fileExtension
      })
    } else {
      setFileDetails({})
    }
  }, [clientSpecificReportDataById?.ReportUrl])

  /** !!!!!!!! handling submit function  !!!!!!!! */
  const [bodyDataForCreate, setBodyDataForCreate] = useState({})
  const onSubmit = (data) => {

    let serviceOfficeList = []
    if (!!serviceOfficeItemsFromDialog) {
      serviceOfficeItemsFromDialog.forEach((item) => {
        serviceOfficeList.push({
          rightOfficeKey: item?.rightOfficeKey,
        })
      })
    }

    let clientSubAccIdTobeSent = ""
    let serviceOfficeListTobeSent = []

    if (data?.visible_to?.selectOptionLabel === "Everyone" ||
      data?.visible_to?.selectOptionLabel === "Client Account") {
      clientSubAccIdTobeSent = "";
      serviceOfficeListTobeSent = [];
    }
    else if (data?.visible_to?.selectOptionLabel === "Client Sub-Account Group") {
      clientSubAccIdTobeSent = data?.client_sub_account?.id;
      serviceOfficeListTobeSent = [];
    }
    else if (data?.visible_to?.selectOptionLabel === "Region") {
      clientSubAccIdTobeSent = data?.client_sub_account?.id;
      serviceOfficeListTobeSent = serviceOfficeList;
    }


    const body = {
      Id: csrId,
      UserId: userId,
      Title: data?.title || "",
      Description: data?.description || "",
      ResourceTypeId: reportsAsResourceType[0]?.Id || "",
      IsActive: true,
      ScopeId: data?.visible_to.id,
      ClientAccountId: data?.client_account?.id,
      ClientSubAccountId: clientSubAccIdTobeSent,
      ClientServiceOffices: serviceOfficeListTobeSent,
      CreatedBy: userName || "",

      /**incase of file update, if new file is not attached then send old file details to api */
      ReportNameFromUrl: clientSpecificReportDataById?.ReportNameFromUrl,
      ReportUrl: clientSpecificReportDataById?.ReportUrl,
      ReportName: clientSpecificReportDataById?.ReportName,
      ReportSize: clientSpecificReportDataById?.ReportSize,
      ReportType: clientSpecificReportDataById?.ReportType,
    };
    setBodyDataForCreate(body)

    if (!!data.csrFile[0]) {
      const file = data.csrFile[0]

      /**merging new file details to body, if exist */
      const splitFileName = file.name.split('.')
      const fileExt = splitFileName.at(-1)
      const bodyData = {
        ...body,
        ReportName: file.name,
        ReportSize: file.size,
        ReportType: fileExt,
      }
      setBodyDataForCreate(bodyData)

      uploadClientSpecificReportFile({ file })
    } else {
      updateReportResource({ body })
    }
  };

  useEffect(() => {
    if (!!dataOnCsrFileUpload?.data?.IsSuccess) {
      const storedFileURL = dataOnCsrFileUpload.data.FileUrl;
      const splitFileURL = storedFileURL.split("/")
      const reportNameFromUrl = splitFileURL.at(-1)
      /**merging file URL to body */
      const bodyData = {
        ...bodyDataForCreate,
        ReportUrl: storedFileURL,
        ReportNameFromUrl: reportNameFromUrl
      }
      updateReportResource({ body: bodyData })
    }
  }, [dataOnCsrFileUpload?.data?.IsSuccess])

  useEffect(() => {
    if (!!isSuccessOnUpdate) {
      navigate(clientSpecificReportViewPath)
    }
  }, [isSuccessOnUpdate])

  /** file download handling  */
  useEffect(() => {
    if (!!isSuccessOnDownload) {
      saveAs(dataOnDownload, `${clientSpecificReportDataById?.ReportName}`);
    }
  }, [isSuccessOnDownload])

  const [isReportPartOfDeactivatedAccOrSubAcc, setIsReportPartOfDeactivatedAccOrSubAcc] = useState(false)
  useEffect(() => {
    if (!!clientSpecificReportDataById?.ClientAccountId) {
      if (!clientSpecificReportDataById?.ClientAccountIsActive) {
        setIsReportPartOfDeactivatedAccOrSubAcc(true)
      } else {
        if (!!clientSpecificReportDataById?.ClientSubAccountId) {
          if (!clientSpecificReportDataById?.ClientSubAccountIsActive) {
            setIsReportPartOfDeactivatedAccOrSubAcc(true)
          } else {
            setIsReportPartOfDeactivatedAccOrSubAcc(false)
          }
        }
      }
    }
  }, [clientSpecificReportDataById])

  /**tracking user Activity */
  const { trackActivity } = useTrackUserActivity()
  useEffect(() => {
    if (!!isSuccessOnDownload) {
      trackActivity({
        activitySuccess: !!isSuccessOnDownload,
        actionType: "Downloaded",
        itemId: fileDetails?.fileGUID || "",
      })
    }
    if (!!isSuccessOnCsrFileUpload) {
      const { fileGUID } = getGUIDAndExtentionFromFileURL({ fileURL: dataOnCsrFileUpload?.data?.FileUrl })

      trackActivity({
        activitySuccess: !!isSuccessOnCsrFileUpload,
        actionType: "Uploaded",
        itemId: fileGUID || "",
      })
    }
  }, [isSuccessOnDownload, isSuccessOnCsrFileUpload])

  /**handling error states and msgs */
  const [errorTitle, setErrorTitle] = useState("")
  const [errorContent, setErrorContent] = useState("")
  useEffect(() => {
    if (!!isErrorOnUpdate && errorOnUpdate?.response?.data === "NoAccessForA4Role") {
      setErrorTitle("Unauthorized action...!")
      setErrorContent("You are not authorized to perform this action.")
    }
    else if (!!isErrorOnCsrFileUpload && errorOnCsrFileUpload?.response
      ?.data?.ErrorCode === "104") {
      setErrorTitle("Opps, file scanning failed...!")
      setErrorContent("You are not authorized to perform this action.")
    }
    else {
      setErrorTitle('')
      setErrorContent("")
    }
  }, [isErrorOnUpdate, errorOnUpdate, isErrorOnCsrFileUpload, errorOnCsrFileUpload])

  const fetchClientSpecificCMSLabel=(key)=>{
    if(refClientSpecificCmsData?.Components && refClientSpecificCmsData?.Components["ClientSpecificReportDetails.Report"]){
       const ClientSpecificCMSDataLabel=refClientSpecificCmsData?.Components["ClientSpecificReportDetails.Report"];
          return returnLabel(ClientSpecificCMSDataLabel?.Labels, key)
    }
    return '';
}
const fetchCommonComponentCMSLabel=(key)=>{
  if(refClientSpecificCmsData?.Components && refClientSpecificCmsData?.Components["CommonComponent"]){
     const clientSubAccountGroupsListCMSDataLabel=refClientSpecificCmsData?.Components["CommonComponent"];
        return returnLabel(clientSubAccountGroupsListCMSDataLabel?.Labels, key)
  }
  return '';
}

const returnLabel = (labelArray=[], key) => {
      return labelArray.find((x) => x.Key === key)?.Phrase || '';
}

  return (
    <Box sx={{ width: "100%" }}>

      <Typography variant="h5" align="center" sx={{ fontWeight: "bolder" }}>
        {fetchClientSpecificCMSLabel('ClientSpecificReportDetails.EditReport')}
      </Typography>

      {
        !!isReportPartOfDeactivatedAccOrSubAcc && (<WarningAlert
          warningMsg={
            `Either client account or client sub-account or both, from where the client user is belonged, are in deactivated status.`
          }
        />)
      }

      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems="center"
        spacing={1}
        m={1}
      >
        <Button
          variant="outlined"
          size="small"
          component={Link}
          to={clientSpecificReportViewPath}
        >
          {fetchClientSpecificCMSLabel('ClientSpecificReportDetails.ClientSpecificReport')}
        </Button>
      </Stack>

      <Box
        component="form"
        noValidate
        autoComplete="off"
        onSubmit={rhfFormInstance.handleSubmit(onSubmit)}
      >
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
            <MpgItem>
              <MpgInput
                rhfFormInstance={rhfFormInstance}
                name={"title"}
                label={fetchClientSpecificCMSLabel('ClientSpecificReportDetails.Title')}
                fullWidth
              />
              <MpgInput
                rhfFormInstance={rhfFormInstance}
                name={"description"}
                label={fetchClientSpecificCMSLabel('ClientSpecificReportDetails.Descripton')}
                multiline
                rows={4}
                fullWidth
              />

              <Grid item xs={12}>
                <MpgFileUpload
                  name="csrFile"
                  label={fetchClientSpecificCMSLabel('ClientSpecificReportDetails.UploadFile')}
                  rhfFormInstance={rhfFormInstance}
                  persistantMsg={fetchClientSpecificCMSLabel('ClientSpecificReportDetails.AllowedFiles')}
                />
                { /** file download func */}
                {
                  !!clientSpecificReportDataById?.ReportUrl && (
                    <MuiLink
                      onClick={() => {
                        if (!!fileDetails?.fileGUID) {
                          DownloadProfileImg({
                            fileGUID: fileDetails?.fileGUID,

                            /**DownloadType: "profileImage"|"logo"|"reportAndResources" */
                            DownloadType: "reportAndResources",
                            Extension: fileDetails?.fileExtension,
                          });
                        }
                      }}
                    >
                      {`${clientSpecificReportDataById?.ReportName}`}
                    </MuiLink>
                  )
                }

              </Grid>
            </MpgItem>
          </Grid>
          <Grid item xs={12} sm={6}>
            <MpgItem>
              <MpgAutocompleteSingle
                rhfFormInstance={rhfFormInstance}
                name={"visible_to"}
                label={fetchClientSpecificCMSLabel('ClientSpecificReportDetails.VisibleTo')}
                fullWidth
                optionList={visibleToAutocompleteList || []}
                onChangeExtraHandler={() => {
                  setValue("client_account", "", {
                    shouldValidate: true,
                  });
                  setValue("client_sub_account", {}, {
                    shouldValidate: true,
                  });
                  setValue("service_office", "", { shouldValidate: true });
                }}
              />

              <MpgAutocompleteSingle
                rhfFormInstance={rhfFormInstance}
                name={"client_account"}
                label={fetchClientSpecificCMSLabel('ClientSpecificReportDetails.ClientAccount')}
                fullWidth
                optionList={clientAccountAutocompleteList || []}
                onChangeExtraHandler={() => {
                  setValue("client_sub_account", {}, {
                    shouldValidate: true,
                  });
                  setValue("service_office", "", { shouldValidate: true });
                }}
                disabled={!!disableClientAccount}
              />

              <MpgAutocompleteSingle
                rhfFormInstance={rhfFormInstance}
                name={"client_sub_account"}
                label={fetchClientSpecificCMSLabel('ClientSpecificReportDetails.ClientSubAccount')}
                fullWidth
                optionList={clientSubAcctAutocompleteList || []}
                onChangeExtraHandler={() => {
                  setValue("service_office", "", { shouldValidate: true });
                }}
                disabled={!!disableClientSubAccount}
              />
              <div>
                <MpgInput
                  rhfFormInstance={rhfFormInstance}
                  name={'service_office'}
                  label={fetchClientSpecificCMSLabel('ClientSpecificReportDetails.ServiceOffices')}
                  multiline
                  rows={4}
                  fullWidth
                  disabled={true}
                />

                <Button
                  onClick={() => { setOpenServiceOfficeDialog(true) }}
                  disabled={!!isLoadingOnServiceOfficeList || !!disableServiceOffice}
                >
                  {
                    !!isLoadingOnServiceOfficeList ? (
                      <Fragment>
                        <CircularProgress
                          size={15}
                          sx={{ margin: '5px' }}
                        />
                        {fetchCommonComponentCMSLabel('Common.Fetching')}
                      </Fragment>
                    ) : (
                      <Fragment>{fetchClientSpecificCMSLabel('ClientSpecificReportDetails.ServiceSelectServiceOfficesOffices')}</Fragment>
                    )
                  }
                </Button>
              </div>
            </MpgItem>
          </Grid>
        </Grid>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent={"space-evenly"}
          mt={3}
        >
          <Button
            variant="outlined"
            type="submit"
            size="small"
            /**if account or sub account is deactivated then disable this button */
            disabled={!!isReportPartOfDeactivatedAccOrSubAcc || !clientSpecificReportDataById?.IsActive}
          >
            {fetchClientSpecificCMSLabel('ClientSpecificReportDetails.UpdateReport')}
          </Button>
        </Stack>
      </Box>

      {  /**dialog */}
      <MpgServiceOfficeDialog
        open={openServiceOfficeDialog}
        setOpen={setOpenServiceOfficeDialog}

        serviceOfficeItemsFromDialog={serviceOfficeItemsFromDialog}
        setServiceOfficeItemsFromDialog={setServiceOfficeItemsFromDialog}

        serviceOfficeListFromAPI={serviceOfficeListData?.data || []}
      />

      {/** error dialog on update action */}
      <MpgErrorDialog
        open={!!isErrorOnUpdate || !!isErrorOnDownload || !!isErrorOnCsrFileUpload}
        title={errorTitle || ""}
        content={errorContent || ""}
      />
      <MpgLoadingDialog
        open={
          !!isLoadingOnUpdate ||
          !!isLoadingOnCsrFileUpload
        }
      />
    </Box>
  );
};

export default EditClientSpecificReport;
